import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStrikethrough = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 640",
		fill: "currentColor",
		...props,
		children: /* @__PURE__ */ _jsx("path", { d: "M160 215.7C160 149.6 213.6 96 279.7 96L440 96C453.3 96 464 106.7 464 120C464 133.3 453.3 144 440 144L279.7 144C240.1 144 208 176.1 208 215.7C208 250.5 233 280.3 267.2 286.3L367.4 304L552 304C565.3 304 576 314.7 576 328C576 341.3 565.3 352 552 352L88 352C74.7 352 64 341.3 64 328C64 314.7 74.7 304 88 304L198.9 304C174.8 281.9 160 250.3 160 215.7zM427.8 400L477.6 400C479.2 407.9 480.1 416 480.1 424.3C480.1 490.4 426.5 544 360.4 544L200 544C186.7 544 176 533.3 176 520C176 506.7 186.7 496 200 496L360.3 496C399.9 496 432 463.9 432 424.3C432 415.8 430.5 407.6 427.8 400z" })
	});
};
export default SvgStrikethrough;
